export const formatDate = (date: Date) => {
  // Check if the date is already in the format YYYY-MM-DD
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  try {
    let year = date.toLocaleString("default", { year: "numeric" });
    let month = date.toLocaleString("default", { month: "2-digit" });
    let day = date.toLocaleString("default", { day: "2-digit" });
    return `${year}-${month}-${day}`;
  } catch (error) {
    return date;
  }
};

export const formatHijriDate = (date: any) => {
  try {
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Pad with zero if needed
    let day = date.getDate().toString().padStart(2, '0'); // Pad with zero if needed
    return `${year}-${month}-${day}`;
  } catch (error) {
    return date;
  }
};

import { getLocalValue,setLocalValue } from "@/hooks/useLocalStorage";
import store from "@/store";
export const formatMobile = (mobile: string) => {
  return mobile ? mobile.replace("-", "") : false;
};

export const tConvert = (time: any) => {
  // Check correct time format and split into components
  time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice (1);  // Remove full string match value
    time[5] = +time[0] < 12 ? 'ص' : 'م'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join (''); // return adjusted time or original string
}

export const formatCreationDate = (date: string) => {
  if(!date) {
    return;
  }
  let dateFormated = date.replace('T', ' ').replaceAll('-', '/').split('.')[0];
  const time = dateFormated.split(' ')[1];
  const dateWithNoTime = dateFormated.split(' ')[0]
  const timeConverted = tConvert(time);

  return dateWithNoTime + ' ' + timeConverted;
}

export const toIndianDigits = (num: string) => {
    const id= ['۰','۱','۲','۳','٤','۵','۶','۷','۸','۹'];
    if(!num) {
        return;
    }
    return num.toString().replace(/\d/g, (w) => {
        return id[+w]
    });
}

export const snakeToCamel = (str: string) =>
  str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    );

export const camelToSnake = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const camelToUpper = (str: string) => {
  if(!str) {
    return false;
  } else {
    const words = str.split("_");
    for (let i = 0; i < words.length; i++) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
    }
    return words.join(' ')
  }
}

export const checkIfExist = (value: any) => {
  return value ? value.label : '';
}

export const displayGender = (str: string) => {
  if(str === "M") {
    return 'رجال';
  } else if(str === "F") {
    return 'النساء';
  } else {
    return 'Invalid value';
  }
}

export const isValidSaudiID = (saudiID: string, validateIqama: boolean = false) => {
    saudiID = saudiID.trim();

    if (isNaN(parseInt(saudiID))) return false;
    if (saudiID.length !== 10) return false;

    let type = saudiID.substr(0, 1);
    if (validateIqama && type !== '2' || !validateIqama && type !== '1') return false;

    let sum = 0;
    for (let i = 0; i < 10; i++) {
        if (i % 2 === 0) {
            let ZFOdd = String('00' + String(Number(saudiID.substr(i, 1)) * 2)).slice(-2);
            sum += Number(ZFOdd.substr(0, 1)) + Number(ZFOdd.substr(1, 1));
        } else {
            sum += Number(saudiID.substr(i, 1));
        }
    }
    return (sum % 10 === 0);
}

export const isValidMobileNumber = (mobileNumber: string | undefined | null) => {
  if (!mobileNumber) {
    return false;
  }
  return /^(009665|9665|\\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/.test(mobileNumber);
};

export const debounce = (func: (...args: any[]) => void, wait = 1000) => {
  let timeout: ReturnType<typeof setTimeout>;
  return function executedFunction(...args: any[]) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const toBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    if (typeof file === 'string' && file.startsWith('data:')) {
      resolve(file);
    } else {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    }
});

export const isHttpUrl = (url : any) => { 
  const getUrl = url?.name ? url.name : url;
  return getUrl?.startsWith('http') || getUrl.startsWith('https');
}

/**
 * A pre-filled file arrives from the backend as a bare absolute URL, while the
 * registration steps render `{ name, size }`. Size is unknown for a stored file,
 * so it stays null and the steps hide that line.
 */
export const prefilledFile = (url: any) => {
  if (!url || typeof url !== 'string') return null;
  const name = decodeURIComponent(url.split('?')[0].split('/').pop() || url);
  return { url, name, size: null };
}

export const scrollIntoView = (identifier:string) => {
  const element = document.querySelector(identifier)
  return element ? element.scrollIntoView({ behavior: 'smooth', block: 'center' }) : null
}

export const scrollNextErrorIntoView = (elId = ".p-invalid, .file-input-invalid") => {
  return scrollIntoView(elId)
}

export const addStepToCharity = (stepKey:any, newValue:any) => {
  // Get the existing charity_request object from local storage
  let charityRequest = getLocalValue('charity_request');
  // Add the new step data to the charity_request object
  charityRequest[stepKey] = newValue;
  // Save the updated charity_request object back to local storage
  setLocalValue('charity_request', charityRequest);
};

export const appendSehattyClass = (classes: any) => {
  if(store.getters.isSehattyPage) {
    return classes + ' sehatty';
  }
  return classes;
};
export const verifySehattyToken = (token: any) => {
  const sehattyToken = process.env.VUE_APP_SEHATTY_TOKEN;  
  return token === sehattyToken;
}

export const formatFileSize = (bytes: any) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024
export const MAX_FILE_SIZE_ERROR_MESSAGE = 'يجب أن يكون حجم الملف أقل من أو يساوي 5 ميجابايت'

export const isFileSizeValid = (file: any) => {
  return !!file && file.size <= MAX_FILE_SIZE_BYTES
}

export const truncateFileName = (fileName: any, extension: any) => {
  if (!fileName) return ''
  return fileName.length > 30 ? fileName.substring(0, 30) + '...' + extension : fileName
}

export async function getRemoteFileSizeWithGet(url: any) {
  const response = await fetch(url);
  if (!response.ok) {
    return;
  }
  const blob = await response.blob();
  return blob.size;
}

export function verifyUrl(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }
  const pattern = new RegExp(
    "^(https?:\\/\\/)" +
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
    "((\\d{1,3}\\.){3}\\d{1,3}))" +
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
    "(\\?[;&a-z\\d%_.~+=-]*)?" +
    "(\\#[-a-z\\d_]*)?$",
    "i"
  );
  return pattern.test(url);
}

export const truncateName = (name: string, length: number) => {
  if (!name) return '';
  return name.length > length ? name.substring(0, length) + '...' : name;
};

export const saudiPhoneValidator = (value: any) => {
  if (!value) return true;

  const cleanValue = value.replace(/[\s\-()]/g, '');
  const pattern = /^(?:\+966|966|0)?(50|51|53|54|55|56|57|58|59)\d{7}$/;
  return pattern.test(cleanValue);
};

export const getDomainWithoutProtocol = () => {
  const url = process.env.VUE_APP_API_URL || '';
  return url.replace(/^https?:\/\//, '');
};